import { createSlice } from '@reduxjs/toolkit';

const SLICE_NAME = 'manualDataValidation';

const initialState = {
  selectedObservationIds: [],
  refreshCount: 0,
};

export const selectSelectedObservationIds = ({ [SLICE_NAME]: base }) => base.selectedObservationIds;
export const selectRefreshCount = ({ [SLICE_NAME]: base }) => base.refreshCount;

export const manualDataValidationSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    setSelectedObservationIds(state, action) {
      state.selectedObservationIds = action.payload;
    },
    addSelectedObservationId(state, action) {
      const observationId = action.payload;

      if (!observationId) return;

      const index = state.selectedObservationIds.findIndex((v) => v === observationId);

      if (index === -1) {
        state.selectedObservationIds = state.selectedObservationIds.concat(observationId);
      }
    },
    removeSelectedObservationId(state, action) {
      const observationId = action.payload;

      if (!observationId) return;

      const index = state.selectedObservationIds.findIndex((v) => v === observationId);

      if (index > -1) {
        state.selectedObservationIds = [
          ...state.selectedObservationIds.slice(0, index),
          ...state.selectedObservationIds.slice(index + 1),
        ];
      }
    },
    clearAllSelectedObservationIds(state) {
      state.selectedObservationIds = [];
    },
    refreshValidation(state) {
      state.refreshCount = state.refreshCount + 1;
    },
  },
});

export const {
  setSelectedObservationIds,
  addSelectedObservationId,
  removeSelectedObservationId,
  clearAllSelectedObservationIds,
  refreshValidation,
} = manualDataValidationSlice.actions;
